import { AiSelectedAnalysisProgressEventEntity } from '@/entities/ai-selected-analysis-progress-event.entity';
import { SocketIoEvents } from '@/events/socket-io.events';
import { MutableRefObject, useEffect } from 'react';

type UseAiAnalysisProgressEventsEffectArgs = {
    events: SocketIoEvents;
    aiAnalysisOperationIdRef: MutableRefObject<string | null>;
    handleAiSelectedAnalysisProgress: (event: AiSelectedAnalysisProgressEventEntity) => void;
};

export const useAiAnalysisProgressEventsEffect = ({
    events,
    aiAnalysisOperationIdRef,
    handleAiSelectedAnalysisProgress,
}: UseAiAnalysisProgressEventsEffectArgs) => {
    useEffect(() => {
        const unsubscribe = events.on('aiSelectedAnalysisProgress', (event) => {
            if (aiAnalysisOperationIdRef.current !== event.operationId) {
                return;
            }

            handleAiSelectedAnalysisProgress(event);
        });

        return () => unsubscribe();
    }, [aiAnalysisOperationIdRef, events, handleAiSelectedAnalysisProgress]);
};
